<div class="container my-4">
    <div class="row">
        @for (action of body.items; track action) {
        <div class="col-auto me-4">
            <app-link [link]="action.button_link" [cssClass]="'btn btn-black'">{{ action.button_title }}</app-link>
        </div>
        }
    </div>
</div>
